import { getDistanceUnit, getPressureUnit, getSpeedUnit, getWindDirection } from './apiConversionUtil';

export class HurricaneUtil {
    constructor() {
        this.hurricaneType = 1;
        this.tropicalStormTypes = [4,7,10];
        this.tropicalDepressionTypes = [3, 6, 9];
        this.pastDtype = 1;
        this.currentDtype = 3;
        this.futureDtype = 4;
    }
    //This method is used to give currentPosition. features-> properties-> dtype=3: This gives current Track Point.

    static getCurrentTrackPoint(hurricane, currentLocation) {
        var notFoundResult = { geometry: { coordinates : [0,0] }, properties: {} };
        if (currentLocation && currentLocation.coords) {
            notFoundResult = { geometry: { coordinates: [Number(currentLocation.coords.longitude), Number(currentLocation.coords.latitude)] } }; }
        if (!hurricane || !hurricane.features) return notFoundResult;
        return hurricane.features.find(x => x.properties && x.properties.dtype === 3) || notFoundResult;
    }

    //This method is used to give hurricane name if we pass any tracepoint to it. trackPoint->properties->tn+trackPoint->properties->n ex- TropicalStorm ALETTA

    getHurricaneName(trackPoint) {
        let name = '';
        let fullName = '';
        if (trackPoint && trackPoint.properties && trackPoint.properties.tn) {
            fullName = trackPoint.properties.tn;
        }
        if (trackPoint && trackPoint.properties && trackPoint.properties.n) {
            fullName = (fullName ? (fullName + ' ') : '') + trackPoint.properties.n;
        }
        name = fullName + name;
        if (trackPoint && trackPoint.properties && trackPoint.properties.cs) {
            name += ' • ' + trackPoint.properties.cs;
        }
        return name;
    }

    //This method is used to give hurricane speed and how many miles away. This method should be split into two later. trackPoint.properties.w + trackPoint.properties.dis
    //ex- 46 mph. 2456 miles away



    getHurricaneGust(trackPoint) {
        if (trackPoint && trackPoint.properties && trackPoint.properties.g) {
            let windSpeed = Math.round(trackPoint.properties.g);
            if (trackPoint.properties.gu) {
                windSpeed += getSpeedUnit(trackPoint.properties.gu);
            }
            return windSpeed;
        }
        return '';
    }

    getHurricaneWind(trackPoint, showUnit) {
        if (trackPoint && trackPoint.properties && trackPoint.properties.w) {
            let windSpeed = Math.round(trackPoint.properties.w);
            if (showUnit && trackPoint.properties.wu) {
                windSpeed += getSpeedUnit(trackPoint.properties.wu);
            }
            return windSpeed;
        }
        return '';
    }

    getHurricaneSpeed(trackPoint) {
        let speed = ' • ';
        speed = this.getHurricaneWind(trackPoint, true) + speed;
        if (trackPoint && trackPoint.properties && trackPoint.properties.diss) {
            speed += ' ' + trackPoint.properties.diss;
        }
        return speed;
    }

    //This method is used to give category icon. For all hurricane categories- trackPoint.properties.c. For TropicalStorm- trackPoint.properties.t=10 For TropicalDepression- trackPoint.properties.t=7
    /*
    This function is only used in the spotlight app and requires importing all of the hurricane images to this file.  We should probably modify the approach when we reintegrate this with the mobile app.
    getCategoryIcon(trackPoint) {
        if (trackPoint && trackPoint.properties && trackPoint.properties.c) {
            const category = trackPoint.properties.c;
	    return hurricaneIcons['spotlight-ic' + category];
        }
        if (trackPoint && trackPoint.properties && trackPoint.properties.t == 10) {
            return hurricaneIcons['spotlight-icTS'];
        }
        if (trackPoint && trackPoint.properties && trackPoint.properties.t == 7) {
            return hurricaneIcons['spotlight-icTD'];
        }
        return hurricaneIcons['spotlight-ic1'];
    }*/
}
